import {InputHTMLAttributes, ReactNode} from "react";
import classNames from "classnames";
import styles from "./Checkbox.module.scss";

type Props = Omit<
    InputHTMLAttributes<HTMLInputElement>,
    "type"
> & {
    label?: ReactNode;
    textPosition?: "left" | "right";
    icon?: ReactNode;
    checkedIcon?: ReactNode;
    inputClassName?: string;
    fullWidth?: boolean;
};

export const Checkbox = (
    {
        label,
        textPosition = "right",
        icon,
        checkedIcon,
        checked = false,
        disabled = false,
        className,
        inputClassName,
        fullWidth,
        ...inputProps
    }: Props
) => {
    const containerClassName = classNames(
        styles.container,
        styles[textPosition],
        className,
        {
            [styles.disabled]: disabled,
            [styles.fullWidth]: fullWidth,
        }
    );

    const defaultIcon = (
        <span className={styles.parent}>
            <span className={styles.child} />
        </span>
    );

    const renderedIcon = checked ? (checkedIcon ?? defaultIcon) : (icon ?? defaultIcon);

    return (
        <label className={containerClassName}>
            <span className={styles.checkbox}>
                <input
                    type={`checkbox`}
                    checked={checked}
                    disabled={disabled}
                    className={classNames(styles.input, inputClassName)}
                    {...inputProps}
                />
                {renderedIcon}
            </span>
            {label !== undefined && label !== null && (<span className={styles.label}>{label}</span>)}
        </label>
    );
};
